'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});



//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/core-js/modules/es7.object.define-getter.js
// module id = 892
// module chunks = 0 1